import React from 'react'
import { FontSizeControlOptions } from '../../../common/TextResize'
import { DEFAULT_FONT_SIZE_CONTROL_OPTIONS } from './contstants'
import { useAnswerMaskingControl, useFontSizeControl } from './hooks'
import { UseAnswerMaskingControl, UseFontSizeControl } from './types'

export type AccessibilityTestMenuContextType = {
  // FontSize
  fontSizeControl: UseFontSizeControl

  // Answer Masking
  answerMaskingControl: UseAnswerMaskingControl
}

export const AccessibilityTestMenuContext = React.createContext<AccessibilityTestMenuContextType | null>(null)

interface Props {
  fontSizeControlOptions?: FontSizeControlOptions
  children?: React.ReactNode
}

const AccessibilityTestMenuProvider: React.FC<Props> = ({
  fontSizeControlOptions = DEFAULT_FONT_SIZE_CONTROL_OPTIONS,
  children,
}) => {
  const fontSizeControl = useFontSizeControl(fontSizeControlOptions)

  const answerMaskingControl = useAnswerMaskingControl()

  return (
    <AccessibilityTestMenuContext.Provider
      value={{
        // FontSize Control
        fontSizeControl,

        // Answer Masking
        answerMaskingControl,
      }}
    >
      {children}
    </AccessibilityTestMenuContext.Provider>
  )
}

export default AccessibilityTestMenuProvider
